import { render, staticRenderFns } from "./SelecionarDependente.vue?vue&type=template&id=44e17e46&"
import script from "./SelecionarDependente.vue?vue&type=script&lang=js&"
export * from "./SelecionarDependente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports